import React, { useCallback, useState } from 'react'
import { Button } from '../../../components/Button/Button'
import { type OAuth2App } from '../../../store/auth/auth'
import { CredentialField } from '../components/CredentialField'
import { DeleteAppModal } from './DeleteAppModal'
import { RotateSecretModal } from './RotateSecretModal'

interface ManageAppCredentialsTabProps {
  oAuth2App: OAuth2App
}

export const ManageAppCredentialsTab: React.FC<ManageAppCredentialsTabProps> = ({ oAuth2App }) => {
  const [showRotateModal, setShowRotateModal] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)

  const handleRotateSecret = useCallback(() => {
    setShowRotateModal(true)
  }, [])

  const handleDeleteApp = useCallback(() => {
    setShowDeleteModal(true)
  }, [])

  return (
    <div>
      <h5 className='fw-bold mb-1'>{oAuth2App.type === 'external' ? 'Sandbox Credentials' : 'Credentials'}</h5>
      <p className='text-muted mb-4'>Use these credentials to integrate with the Zocks API.</p>

      <div className='mb-3'>
        <CredentialField label='Client ID' value={oAuth2App.clientId} copyable />
      </div>

      <div className='mb-4'>
        <CredentialField
          label='Client Secret'
          value={"Saved during app creation. Can't be retrieved again"}
          valueIcon={<i className='bi bi-lock' />}
          action={
            <Button variant='darkGhost' onClick={handleRotateSecret} className='ms-2 flex-shrink-0'>
              Rotate
            </Button>
          }
        />
      </div>

      <p className='text-muted small mb-4'>
        Need help? Contact us at{' '}
        <a href='mailto:support@zocks.io' className='text-decoration-none'>
          support@zocks.io
        </a>
      </p>

      <hr className='my-4' />

      <div className='mb-3'>
        <h6 className='fw-bold text-danger'>Danger zone</h6>
        <p className='text-muted small'>Deleting this app will immediately revoke all tokens and remove access for all connected accounts.</p>
      </div>

      <Button variant='danger' onClick={handleDeleteApp}>
        Delete app
      </Button>

      <RotateSecretModal show={showRotateModal} clientId={oAuth2App.clientId} onHide={() => setShowRotateModal(false)} />
      <DeleteAppModal show={showDeleteModal} clientId={oAuth2App.clientId} appName={oAuth2App.name} onHide={() => setShowDeleteModal(false)} />
    </div>
  )
}
